export const JSON_Bank_Ifcs16 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VVPA28311712855182658FAE"
    }
};

export const JSON_Bank_Ifcs17 = {
    "code":"0x0202",
    "status":"FAILURE",
    "message":"Insufficient funds"
};
